import JobDepartment  from ".";

export const jobDepartmentRoutes = () => [
  {
    path: "/admin/job-departments",
    component: JobDepartment,
    layout: "admin",
    routeType: "admin",
    title: "Jobs Management",
  },
];
